import { useModal } from 'components/common/ModalLayout';
import hubLayout from 'styles/css/hubLayout.module.css';
import styled from "styled-components";
import React from "react";

const ModalMask = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99999;
  background-color: rgba(0,0,0,.7);
  width: 100%;
  height: 100%;
`
const ModalComponent = styled.div`
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  width: 20rem;
  border-radius: 1rem;
  background-color: #fff;
  border: 1px solid #1568dd;
  box-shadow: none;
  z-index: 100000;
`;
const ModalHeader = styled.div`
  height: 3rem;
  padding: 0.5rem 1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 0.25rem;
  border-bottom: 1px solid #1568dd;
  p {
    color:#1568dd;
    font-weight: bold;
    font-size: 16px;
  }
  button {
    background: none;
    color: #666;
  }
`;
const ModalContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: space-between;
  margin: 1rem 2rem;
`;
const ModalFormWrap = styled.div`
  width: 100%;
  border-radius: 1rem;
  form {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    min-height: 12.5rem;
    height: 100%;
    justify-content: space-between;
  }
  .content {
    text-align: center;
    margin: 2rem 0;
    font-size: 16px;
  }
  .button-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    height: 3rem;
    gap: 1rem;
    button {
      margin-left: auto;
      padding: 0.5rem;
      padding: 0.5rem 1rem;
      border-radius: 4px;
      background-color: #1568dd;
      color: #ffffff;
      &:hover {
        cursor: pointer;
        background-color: #1568ddb8;
        color: #ffffff;
      }
    }
  }
`;

export const GlobalModal = () => {
  const { modalState, hideModal } = useModal();

  if (!modalState.isVisible) return null;

  // CAUTION: ios에서 location 명령어가 전달되지 않는 코드 방어용. hideModal시 history.back 되는 코드 방어용
  const handleConfirm = () => {
    if (modalState.onConfirm) modalState.onConfirm();
    if (!modalState.appLink?.confirm) {
      hideModal();
    }
  };

  // CAUTION: ios에서 location 명령어가 전달되지 않는 코드 방어용. hideModal시 history.back 되는 코드 방어용
  const handleCancel = () => {
    if (modalState.onCancel) modalState.onCancel();
    if (!modalState.appLink?.cancel) {
      hideModal();
    }
  };
  return (
    <>
      <ModalMask />
      <ModalComponent>
        <ModalHeader className="font-bold">
          <p>FOCUS VIEW</p>
          <button type="button" onClick={handleCancel}>X</button>
        </ModalHeader>
        <ModalContent>
          <ModalFormWrap>
            <p className="content font-bold" style={{ color: '#272727'}}>
              {modalState.message.split('\n').map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))}</p>
            {modalState.type === 'alert' ? (
              <div className={`${hubLayout.btn_group}`}>
                <button type="button" className={`${hubLayout.btn} ${hubLayout.large} ${hubLayout.blue}`} onClick={handleConfirm}>확인</button>
              </div>
            ) : (
              <div className={`${hubLayout.btn_group}`}>
                <button type="button" className={`${hubLayout.btn} ${hubLayout.large} ${hubLayout.pink}`} onClick={handleCancel}>취소</button>
                <button type="button" className={`${hubLayout.btn} ${hubLayout.large} ${hubLayout.blue}`} onClick={handleConfirm}>확인</button>
              </div>
            )}
          </ModalFormWrap>
        </ModalContent>
      </ModalComponent>
    </>
  );
};